export const WEEKLY_SCHEDULING_LABELS = {
	daysToRunScan: 'Days to run scan',
	time: 'Start time',
	timezone: 'Time zone'
};
